<template>
    <div>
        <div class="box">
            <nav class="level">
                <b-field>
                    <b-radio-button v-model="langFilter" native-value="en" type="is-primary">
                        <b-tooltip label="English">
                            <img class="flag-img" src="/images/uk.png" />
                        </b-tooltip>
                    </b-radio-button>
                    <b-radio-button v-model="langFilter" native-value="ar" type="is-primary">
                        <b-tooltip label="Arabic">
                            <img class="flag-img" src="/images/iq.png" />
                        </b-tooltip>
                    </b-radio-button>
                    <b-radio-button v-model="langFilter" native-value="ku" type="is-primary">
                        <b-tooltip label="Kurdish">
                            <img class="flag-img" src="/images/krd.png" />
                        </b-tooltip>
                    </b-radio-button>
                </b-field>
            </nav>
            <b-table
                narrowed
                bordered
                striped
                :sticky-header="stickyHead"
                :height="stickyHead ? '720px' : undefined"
                :data="filteredItems"
                :loading="isLoading"
                hoverable
                icon-pack="fas"
            >
                <b-table-column
                    v-for="(col, index) in columns"
                    :key="index"
                    :field="col.field"
                    :label="col.label"
                    :sortable="col.sortable"
                    v-slot="props"
                >
                    <template v-if="col.langFlags">
                        <b-tooltip label="English" :key="props.row[col.field]" v-if="props.row[col.field] == 'en'">
                            <img class="flag-img" src="/images/uk.png" />
                        </b-tooltip>
                        <b-tooltip label="Arabic" :key="props.row[col.field]" v-if="props.row[col.field] == 'ar'">
                            <img class="flag-img" src="/images/iq.png" />
                        </b-tooltip>
                        <b-tooltip label="Kurdish" :key="props.row[col.field]" v-if="props.row[col.field] == 'ku'">
                            <img class="flag-img" src="/images/krd.png" />
                        </b-tooltip>
                    </template>

                    <template v-else-if="col.formatDate">
                        {{ props.row[col.field] | formatDate }}
                    </template>
                    <template v-else-if="col.formatNumber">
                        {{ props.row[col.field] | formatNumber }}
                    </template>
                    <template v-else-if="col.mapToIcon">
                        <b-tooltip
                            :type="item.type"
                            :label="`${item.label ? item.label : props.row[col.field]}`"
                            v-for="(item, index) in col.mapToIcon"
                            :key="index"
                        >
                            <b-icon v-if="item.value === props.row[col.field]" :key="index" :icon="item.icon" :type="item.type" />
                            <template v-else>
                                <template v-if="item.else">
                                    {{ props.row[col.field] }}
                                </template>
                            </template>
                        </b-tooltip>

                        <template> </template>
                    </template>
                    <template v-else>
                        {{ props.row[col.field] }}
                    </template>
                </b-table-column>

                <b-table-column label="Actions" width="135" v-slot="props">
                    <b-tooltip label="Edit">
                        <a @click="$router.push(`${$route.path}/${props.row.id}`)">
                            <b-icon icon="file-document-edit-outline"></b-icon>
                        </a>
                    </b-tooltip>
                    <!-- <b-tooltip label="Delete" type="is-danger">
                        <a @click="deleteItem(props.row.id, 'delete')">
                            <b-icon icon="delete" type="is-danger"></b-icon>
                        </a>
                    </b-tooltip> -->
                </b-table-column>

                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>
                                <b-icon icon="frown" pack="far" size="is-large"></b-icon>
                            </p>
                            <p>Nothing here.</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            itemName: "Achievement",
            apiURI: "/achivements",
            items: [],
            langFilter: "en",
            columns: [
                {
                    field: "id",
                    label: "ID",
                    width: "40",
                    numeric: true,
                },
                {
                    field: "text",
                    label: "Title",
                },
                {
                    field: "value",
                    label: "Value",
                },
                {
                    field: "lang",
                    label: "Language",
                    langFlags: true,
                },
            ],
            isLoading: true,
            stickyHead: false,
        };
    },
    methods: {
        async init() {
            this.loadTable();
        },
        onPageChange(page) {
            this.page = page;
            this.loadTable();
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.loadTable();
        },
        async loadTable() {
            this.isLoading = true;
            let params = [
                `page=${this.page}`,
                `sort=${this.sortField}`,
                `order=${this.sortOrder}`,
                this.searchQuery ? `search=${this.searchQuery}` : "",
            ].join("&");
            try {
                let res = await this.$http.get(this.apiURI + "?" + params);
                this.items = res.data;
            } catch (error) {
                this.items = [];
                this.total = 0;
                this.page = 1;
            }
            this.isLoading = false;
        },
        search() {
            if (this.searchQuery == "") {
                this.searchStr = "";
            } else {
                this.searchStr = "&" + `search=${this.searchQuery}`;
            }
            this.page = 1;
            this.loadTable();
        },
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {},
    computed: {
        filteredItems() {
            return this.items.filter((item) => item.lang == this.langFilter);
        },
    },
};
</script>

